import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  return (
    <div data-testid="payment-success-page" className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <CheckCircle className="w-16 h-16 mx-auto text-[#56dfb4] mb-4" />
        <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Payment Successful!</h1>
        <p className="text-slate-500 mb-6">Your subscription is now active. You have full access to all features.</p>
        <Button
          onClick={() => navigate('/dashboard')}
          className="rounded-full bg-[#56dfb4] text-slate-900 hover:bg-[#3ec49b] px-8"
          data-testid="payment-go-dashboard"
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
